export function getCarrouselConfigurationOption(type, key) {

  const options = {
    "html.InstagramCarrouselBox": {
      "carrousel-has-aspect-ratio": true,
      "carrousel-aspect-ratio-required": false,
      "carrousel-has-card-width": false,
      "carrousel-card-width-required": false,
      "carrousel-has-image-size": false,
      "carrousel-image-size-required": false,
      "carrousel-has-alt-text": false,
      "carrousel-element-can-have-picture": true,
      "carrousel-element-has-media-height": false,
      "carrousel-element-can-have-title": true,
      "carrousel-element-title-required": true,
      "carrousel-element-can-have-subtitle": true,
      "carrousel-element-subtitle-required": false,
      "carrousel-element-can-have-default-action": true,
      "carrousel-element-can-have-background-color": false,
      "carrousel-element-title-max-length": 80,
      "carrousel-element-subtitle-max-length": 80,
      "carrousel-element-button-title-max-length": 20,
      "carrousel-element-alt-text-max-length": 0,
      "carrousel-must-have-uniform-elements": false,
      "carrousel-must-check-button-validity": false,
      "carrousel-must-check-number-of-button-validity": false,
      "max-carrousel-elements-number": 10,
      "max-carrousel-element-buttons-number-several-slide": 3,
      "max-carrousel-element-buttons-number-one-slide": 3,
      "carrousel-element-validation-function": function (elementData) {
        return !!elementData.title;
      },
    },
    "html.GbmCarrouselBox": {
      "carrousel-has-aspect-ratio": false,
      "carrousel-aspect-ratio-required": false,
      "carrousel-has-card-width": true,
      "carrousel-card-width-required": true,
      "carrousel-has-image-size": false,
      "carrousel-image-size-required": false,
      "carrousel-has-alt-text": false,
      "carrousel-element-can-have-picture": true,
      "carrousel-element-has-media-height": true,
      "carrousel-element-media-height-required": true,
      "carrousel-element-can-have-title": true,
      "carrousel-element-title-required": false,
      "carrousel-element-can-have-subtitle": true,
      "carrousel-element-subtitle-required": false,
      "carrousel-element-can-have-default-action": false,
      "carrousel-element-can-have-background-color": false,
      "carrousel-element-title-max-length": 200,
      "carrousel-element-subtitle-max-length": 2000,
      "carrousel-element-button-title-max-length": 25,
      "carrousel-element-alt-text-max-length": 0,
      "carrousel-must-have-uniform-elements": false,
      "carrousel-must-check-button-validity": false,
      "carrousel-must-check-number-of-button-validity": false,
      "max-carrousel-elements-number": 10,
      "max-carrousel-element-buttons-number-several-slide": 4,
      "max-carrousel-element-buttons-number-one-slide": 4,
      "carrousel-element-validation-function": function (elementData) {
        return !!elementData.title || !!elementData.subtitle || !!elementData.pictureId;
      },
    },
    "html.LineCarrouselBox": {
      "carrousel-has-aspect-ratio": true,
      "carrousel-aspect-ratio-required": false,
      "carrousel-has-card-width": false,
      "carrousel-card-width-required": false,
      "carrousel-has-image-size": true,
      "carrousel-image-size-required": false,
      "carrousel-has-alt-text": true,
      "carrousel-element-can-have-picture": true,
      "carrousel-element-has-media-height": false,
      "carrousel-element-media-height-required": false,
      "carrousel-element-can-have-title": true,
      "carrousel-element-title-required": false,
      "carrousel-element-can-have-subtitle": true,
      "carrousel-element-subtitle-required": true,
      "carrousel-element-can-have-default-action": true,
      "carrousel-element-can-have-background-color": true,
      "carrousel-element-title-max-length": 40,
      "carrousel-element-subtitle-max-length-with-image": 60,
      "carrousel-element-subtitle-max-length-one-slide": 160,
      "carrousel-element-subtitle-max-length-several-slide": 120,
      "carrousel-element-button-title-max-length": 20,
      "carrousel-alt-text-max-length": 400,
      "carrousel-must-have-uniform-elements": true,
      "carrousel-must-check-button-validity": true,
      "carrousel-must-check-number-of-button-validity": true,
      "max-carrousel-elements-number": 10,
      "max-carrousel-element-buttons-number-several-slide": 3,
      "max-carrousel-element-buttons-number-one-slide": 4,
      "carrousel-element-validation-function": function (elementData) {
        return !!elementData.subtitle;
      },
    },
    "html.InMessageCarouselBox": {
      "carrousel-has-aspect-ratio": true,
      "carrousel-aspect-ratio-required": false,
      "carrousel-has-card-width": false,
      "carrousel-card-width-required": false,
      "carrousel-has-image-size": false,
      "carrousel-image-size-required": false,
      "carrousel-has-alt-text": false,
      "carrousel-element-can-have-picture": true,
      "carrousel-element-has-media-height": false,
      "carrousel-element-can-have-title": true,
      "carrousel-element-title-required": true,
      "carrousel-element-can-have-subtitle": true,
      "carrousel-element-subtitle-required": true,
      "carrousel-element-can-have-default-action": false,
      "carrousel-element-can-have-background-color": false,
      "carrousel-element-title-max-length": 80,
      "carrousel-element-subtitle-max-length-with-image": 80,
      "carrousel-element-subtitle-max-length-several-slide": 120,
      "carrousel-element-button-title-max-length": 20,
      "carrousel-element-alt-text-max-length": 0,
      "carrousel-must-have-uniform-elements": false,
      "carrousel-must-check-button-validity": false,
      "carrousel-must-check-number-of-button-validity": false,
      "max-carrousel-elements-number": 10,
      "max-carrousel-element-buttons-number-several-slide": 5,
      "max-carrousel-element-buttons-number-one-slide": 5,
      "carrousel-element-validation-function": function (elementData) {
        return !!elementData.title;
      },
    },
  }
  if (options[type] && options[type][key] !== undefined) {
    return options[type][key];
  }
  return null;
}
